<template>
    <v-container fill-height fluid="" pa-0="">
        <v-row align="center" justify="center" no-gutters>
            <v-scale-transition>
                <animation id="star"
                           loop
                           style="height: 300px; width: 300px; position: absolute; top: 50px; transform: translateX(8px);"
                           url="/animations/star.json"
                           v-if="prevPlan && mode === 'in'"
                ></animation>
            </v-scale-transition>
            <v-col cola="12">
                <v-row align="center"
                       class="flex-nowrap"
                       justify="center"
                       no-gutters
                       v-if="currentPhase"
                >
                    <div class="main-bar">
                        <div class="filling-bar"
                             :class="$vuetify.rtl ? 'bar-rtl' : 'bar-ltr'"
                             id="filling-bar"
                        >
                            <div class="px-2 text-uppercase" style="position: absolute; font-size: 13px;">
                                <b>{{ $t('components.journey_progress_bar.start') }}</b> {{ $ta(currentPhase.title_textassetid) }}
                            </div>
                        </div>
                    </div>
                    <v-row :align="!(index % 2) ? 'start' : 'end'"
                           :id="'measure_section_'+plan.journeyplanid"
                           :key="plan.journeyplanid"
                           :style="{ 'max-width': plan.measure.time_estimation * getTimeInterval > 70 ? (plan.measure.time_estimation * getTimeInterval)+'px' : 70+'px' }"
                           no-gutters
                           style="height: 200px;"
                           v-for="(plan, index) in currentPhase.journeyplan.filter((plan) => plan.measure.measure_type !== 'rater_only')"
                    >
                        <v-col cols="12">
                            <v-avatar
                                :class="{ 'star-container-nudge-top-rtl': (index % 2 === 0) && $vuetify.rtl,
                                          'star-container-nudge-bottom-rtl': !(index % 2 === 0) && $vuetify.rtl,
                                          'star-container-nudge-top-ltr': (index % 2 === 0) && !$vuetify.rtl,
                                          'star-container-nudge-bottom-ltr': !(index % 2 === 0) && !$vuetify.rtl }"
                                color="rgba(255,255,255,0.2)"
                                size="48"
                                style="position: absolute; box-shadow: 0 0 0 4px rgba(255,255,255,0.4);"
                                v-if="(prevPlan && (plan.measureorder <= prevPlan.measureorder) && mode === 'static')
                                || (prevPlan && (plan.measureorder < prevPlan.measureorder && mode === 'in'))
                                || (completed && currentPlan && (plan.measureorder <= currentPlan.measureorder))"
                            >
                                <animation style="height: 60px; width: 60px; position: absolute;"
                                           url="/animations/star.json"
                                ></animation>
                            </v-avatar>
                            <v-fade-transition>
                                <v-avatar
                                    :class="{ 'star-container-nudge-top-rtl': (index % 2 === 0) && $vuetify.rtl,
                                               'star-container-nudge-bottom-rtl': !(index % 2 === 0) && $vuetify.rtl,
                                               'star-container-nudge-top-ltr': (index % 2 === 0) && !$vuetify.rtl,
                                               'star-container-nudge-bottom-ltr': !(index % 2 === 0) && !$vuetify.rtl }"
                                    color="rgba(255,255,255,0.2)"
                                    size="48"
                                    style="position: absolute; box-shadow: 0 0 0 3px rgba(255,255,255,0.4);"
                                    v-if="prevPlan && (plan.journeyplanid === prevPlan.journeyplanid) && showStar"
                                ></v-avatar>
                            </v-fade-transition>
                            <v-avatar
                                :class="{ 'avatar-nudge-top-rtl': (index % 2 === 0) && $vuetify.rtl,
                                           'avatar-nudge-bottom-rtl': !(index % 2 === 0) && $vuetify.rtl,
                                           'avatar-nudge-top-ltr': (index % 2 === 0) && !$vuetify.rtl,
                                           'avatar-nudge-bottom-ltr': !(index % 2 === 0) && !$vuetify.rtl }"
                                :id="'plan_avatar_'+plan.journeyplanid"
                                size="82"
                                style="box-shadow: 0 0 0 4px rgba(255,255,255,0.2); position: absolute;"
                                v-if="(plan.journeyplanid === currentPlanId && !completed && active)
                                || (prevPlan && plan.journeyplanid === prevPlan.journeyplanid && mode === 'in' && !completed && active)"
                            >
                                <v-img :src="$store.state.assessment.assessment.profilepic.internal_thumbnail_url || $store.state.assessment.assessment.profilepic.thumbnail_url"
                                       style=" border: 1px solid white;"
                                ></v-img>
                            </v-avatar>
                            <v-fade-transition>
                                <v-row :align="!(index % 2) ? 'start' : 'end'"
                                       :style="{ 'max-width': plan.measure.time_estimation * getTimeInterval > 70 ? (plan.measure.time_estimation * getTimeInterval)+'px' : 70+'px' }"
                                       class="py-1"
                                       :class="$vuetify.rtl ? 'measure-section-rtl' : 'measure-section-ltr'"
                                       no-gutters
                                       v-show="!(plan.measureorder > currentPlan.measureorder && hideUpcomingPlans) || isFirstMeasure"
                                >
                                    <v-col :class="{ 'glow-text': (plan.journeyplanid === currentPlanId && !addGlowEffect && !completed && active)
                                                     || (plan.journeyplanid === currentPlan.journeyplanid && addGlowEffect && !completed && active)}"
                                           cols="12"
                                           style="line-height: 1.1;"
                                    >
                                        <div class="font-weight-bold mb-1"
                                             style="font-size: 13px; max-height: 15px; white-space: nowrap;"
                                        >
                                            {{ $ta(plan.measure.title_textassetid) }}
                                        </div>
                                        <div
                                            style="font-size: 12px; max-width: 110px; max-height: 60px; color: lightgray; line-height: 1;">
                                            {{ $ta(plan.measure.description_textassetid) }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-fade-transition>
                        </v-col>
                    </v-row>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Animation from "../display/Animation";
    import {TimelineLite, TweenMax, Back} from 'gsap';

    export default {
        name: "JourneyProgressBar",
        components: {
            Animation
        },
        props: {
            currentPhase: {
                required: true,
                type: Object
            },
            mode: {
                type: String,
                default: 'static'
            },
            delay: {
                type: Number,
                default: 1000
            },
            completed: {
                type: Boolean,
                default: false
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            getTimeInterval() {
                return ((innerWidth - (innerWidth * 0.15)) / this.currentPhase.time_estimation)
            },
            isFirstMeasure() {
                return this.$store.getters['assessment/isCurrentMeasureFirstInPhase'];
            },
            currentPlanId() {
                let found = this.currentPhase.journeyplan.find((plan) => plan.journeyplanid === this.$store.state.assessment.journeyplan.journeyplanid);
                if(found) {
                    return this.$store.state.assessment.journeyplan.journeyplanid;
                } else  {
                    return this.currentPhase.journeyplan[0].journeyplanid;
                }
            },
            currentPlan() {
                if(this.completed) {
                    return this.lastPlan;
                } else {
                    return this.currentPhase.journeyplan.find((plan) => plan.journeyplanid === this.currentPlanId) || this.currentPhase.journeyplan[0];
                }
            },
            prevPlan() {
                if (this.isFirstMeasure && this.mode === 'in') {
                    return null;
                } else {
                    return this.currentPhase.journeyplan.find((plan) => plan.measureorder === (this.currentPlan.measureorder - 1));
                }
            },
            lastPlan() {
                return this.currentPhase.journeyplan[this.currentPhase.journeyplan.length - 1];
            }
        },
        data: () => ({
            addGlowEffect: false,
            hideUpcomingPlans: true,
            showStar: false,
            barTimeLine: null,
            processTimeLine: null,
            fillBarWidth: 0,
            prevAvatar: null,
        }),
        methods: {
            setBarProgress() {
                this.barTimeLine = new TimelineLite({paused: true});
                this.processTimeLine = new TimelineLite({paused: true});
                this.$nextTick(() => {
                    if(this.active) {
                        const direction = this.$vuetify.rtl ? 'right' : 'left';
                        let width = document.getElementById('measure_section_' + this.currentPlanId).getBoundingClientRect()[direction];
                        if(this.$vuetify.rtl) {
                            this.fillBarWidth = innerWidth - width;
                        } else {
                            this.fillBarWidth = width;
                        }
                    } else if(this.completed) {
                        this.fillBarWidth = innerWidth + 10;
                    } else {
                        this.fillBarWidth = 10;
                    }
                    if(this.mode === 'in') {
                        this.initAnimations();
                    } else {
                        this.barTimeLine.fromTo('#filling-bar', 1, {width: 0},
                            {
                                width: this.fillBarWidth + 10,
                                ease: Back.easeOut.config(1)
                            });
                    }
                });
            },
            initAnimations() {
                if (this.prevPlan) {
                    this.prevAvatar = document.getElementById('plan_avatar_' + this.prevPlan.journeyplanid).getBoundingClientRect();
                }
                if (this.prevPlan) {
                    let star = document.getElementById('star').getBoundingClientRect(),
                        // starX = (this.prevAvatar.left - 89) - star.left,
                        starX = (this.prevAvatar.left - (this.$vuetify.rtl ? 109 : 89)) - star.left,
                        starY = (this.prevAvatar.top - star.top) - (this.prevPlan.measureorder % 2 === 0 ? 0 : 34);
                    TweenMax.fromTo('#plan_avatar_' + this.prevPlan.journeyplanid, 0.8, {
                        scale: 1,
                        opacity: 1
                        },
                        {
                            scale: 0.6,
                            opacity: 0,
                            y: this.prevPlan.measureorder % 2 === 0 ? 19 : -19
                        });
                    this.processTimeLine.to('#plan_avatar_' + this.prevPlan.journeyplanid, 0.8, {
                        scale: 0.6,
                        opacity: 0,
                        y: this.currentPlan.measureorder % 2 === 0 ? 19 : -19
                    })
                        .fromTo('#plan_avatar_' + this.currentPlan.journeyplanid, 0.8, {
                                scale: 0.6,
                                opacity: 0
                            },
                            {
                                scale: 1,
                                opacity: 1,
                                onStart: () => {
                                    setTimeout(() => {
                                        this.showStar = true;
                                    }, 450);
                                },
                                onComplete: () => {
                                    this.addGlowEffect = true;
                                    this.hideUpcomingPlans = false;
                                }
                            }, '-=0.8')
                        .to('#star', 1.5, {
                            bezier: [
                                {x: starX - 10, y: starY - 10},
                                {x: starX - 1, y: starY + 28}
                            ],
                            rotation: 360,
                            width: 60,
                            height: 60,
                            'margin-left': -18,
                            ease: Back.easeOut.config(0.7),
                        }, '-=0.8');
                }
                this.barTimeLine.fromTo('#filling-bar', 1, {width: 0},
                    {
                        width: this.fillBarWidth + 10,
                        ease: Back.easeOut.config(1)
                    });
            }
        },
        mounted() {
            if(!this.isFirstMeasure && this.mode === 'in') {
                TweenMax.set('#plan_avatar_' + this.currentPlanId, {opacity: 0});
            }
            this.hideUpcomingPlans = this.mode !== 'static';
            setTimeout(() => {
                this.setBarProgress();
                this.barTimeLine.play();
                this.processTimeLine.play();
            }, this.delay);
        }
    }
</script>

<style scoped>
    .main-bar {
        height: 18px;
        width: 100%;
        background-color: rgba(255, 255, 255, 0.2);
        position: absolute;
    }

    .filling-bar {
        background-color: rgba(255, 255, 255, 0.4);
        height: 18px;
        width: 0;
    }

    .bar-rtl {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .bar-ltr {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    .measure-section-ltr {
        border-left: 3px solid rgba(255, 255, 255, 1);
        padding-left: 5px;
        height: 91px;
        min-width: 140px;
    }

    .measure-section-rtl {
        border-right: 3px solid rgba(255, 255, 255, 1);
        padding-right: 5px;
        height: 91px;
        min-width: 140px;
    }

    .avatar-nudge-top-ltr {
        margin-top: -86px;
        margin-left: -41px;
    }

    .avatar-nudge-bottom-ltr {
        margin-top: 95px;
        margin-left: -41px;
    }

    .avatar-nudge-top-rtl {
        margin-top: -86px;
        margin-right: -41px;
    }

    .avatar-nudge-bottom-rtl {
        margin-top: 95px;
        margin-right: -41px;
    }

    .star-container-nudge-top-rtl {
        margin-top: -52px;
        margin-right: -22px;
    }

    .star-container-nudge-bottom-rtl {
        margin-top: 95px;
        margin-right: -23px;
    }

    .star-container-nudge-top-ltr {
        margin-top: -52px;
        margin-left: -22px;
    }

    .star-container-nudge-bottom-ltr {
        margin-top: 95px;
        margin-left: -23px;
    }

    .glow-text {
        -webkit-animation: glow 1s ease-in-out forwards alternate;
        -moz-animation: glow 1s ease-in-out forwards alternate;
        animation: glow 1s ease-in-out forwards alternate;
    }

    @-webkit-keyframes glow {
        20% {
            text-shadow: 0 0 0 #fff;
        }

        100% {
            text-shadow: 0 0 8px #fff;
        }
    }
</style>